import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_K1E5wBJ4VAmI: {
	id: 'prd_K1E5w2DEV2BJ4VAmI'
	ident: 'prd_K1E5wBJ4VAmI'
	sku: 'simple_premium_4w_11_99_4w_57_99_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: 1
			price_id: 'prc_nftCs2DEV2jMgTsa4'
			amount: 57.99
			amount_usd: 11.99
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 11.99
			discount: 46
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: null
			price_id: 'prc_xvVnR2DEV2GDJqnxD'
			amount: 57.99
			amount_usd: 57.99
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_K1E5wBJ4VAmI, SubscriptionProduct>
const prd_K1E5wBJ4VAmI = { ident: 'prd_K1E5wBJ4VAmI' } as typeof _prd_K1E5wBJ4VAmI

export default prd_K1E5wBJ4VAmI
